module.exports = __webpack_public_path__ + "img/logo.616c9098.png";